import type { FC, PropsWithChildren } from 'react';
import React, { useContext, createContext, useState } from 'react';

export interface IErrorData {
  fieldName?: string;
  errorCode?: string;
}

export const FormErrorContext = createContext<{
  errorData: { customErrors?: IErrorData[]; setErrorData: (errorData: IErrorData[]) => void };
}>({
  errorData: {
    setErrorData: () => {},
  },
});

export const FormErrorProvider: FC<PropsWithChildren> = ({ children }) => {
  const [customErrors, setErrorData] = useState<IErrorData[]>([]);

  return (
    <FormErrorContext.Provider
      value={{
        errorData: { customErrors, setErrorData },
      }}
    >
      {children}
    </FormErrorContext.Provider>
  );
};

export const useFormError = () => {
  const ctx = useContext(FormErrorContext);

  return {
    context: ctx,
  };
};
